import { useCallback } from 'react'
import { useMediaQuery } from 'react-responsive'
import { useNavigate } from 'react-router-dom'

import { Desktop } from '@/lib/media/requests'
import Button from '@/ui/Button/Button'
import Logo from '@/ui/icons/Logo'
import classNames from 'classnames'

import styles from './styles.module.scss'

const NotFound404Page = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 })
  const navigate = useNavigate()

  const onClick = useCallback(() => {
    navigate('/')
  }, [navigate])
  return (
    <div className={styles.page}>
      <div className={styles.page_container}>
        <div className={styles.icon}>
          <a href="https://2gis.ru" target="_blank" rel="noopener noreferrer">
            <Logo />
          </a>
        </div>
        <div className={styles.content}>
          <h1
            className={classNames('text', 'text_color_primary', styles.heading)}
          >
            404
          </h1>
          <div className={styles.texts}>
            <p
              className={classNames(
                'text',
                't-header-h5',
                'text_color_primary',
              )}
            >
              Упс! Что-то пошло не&nbsp;так
            </p>
            <p
              className={classNames(
                styles.paragraph,
                'text',
                't-body',
                'text_color_primary',
              )}
            >
              Пока эта страница не&nbsp;доступна, но&nbsp;нам есть о&nbsp;чем
              вам рассказать
            </p>
          </div>

          <Button
            type="accent"
            className={classNames(styles.button, 't-button')}
            onClick={onClick}
          >
            {isMobile ? 'Вернуться' : 'Вернуться к рекордам'}
          </Button>
        </div>
        <Desktop>
          <div className={styles.star} />
        </Desktop>
      </div>
      <div className={styles.goblet} />
      <Desktop>
        <div className={styles.leftline} />
      </Desktop>
      <Desktop>
        <div className={styles.topline} />
      </Desktop>
    </div>
  )
}

export default NotFound404Page
